import { useLocation, useNavigate } from "react-router-dom";
import styles from "./PaymentSuccessPage.module.css";
import Button from "../../components/UI/Button/Button";

export default function PaymentSuccessPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state ?? null;
  const paymentData = state?.paymentData ?? null;
  const paymentType = state?.type ?? null;

  const handleGoToBilling = () => {
    navigate("/billing");
  };

  const handleGoToPortal = () => {
    navigate("/");
  };

  const handleDownloadReceipt = () => {};

  const formatCurrency = (amount, currency = "RON") => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currency,
    }).format(amount);
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return "N/A";

    try {
      const date = new Date(timestamp);

      if (Number.isNaN(date.getTime())) {
        return "Invalid Date";
      }

      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch {
      return "Invalid Date";
    }
  };

  return (
    <div className={styles.successPage}>
      <div className={styles.container}>
        <div className={styles.successCard}>
          <div className={styles.iconContainer}>
            <div className={styles.successIcon}>
              <svg
                width="64"
                height="64"
                viewBox="0 0 24 24"
                fill="none"
                aria-hidden
              >
                <circle cx="12" cy="12" r="10" fill="#10b981" />
                <path
                  d="M9 12l2 2 4-4"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>

          <div className={styles.messageContainer}>
            <h1 className={styles.title}>Payment Successful!</h1>
            <p className={styles.subtitle}>
              Your payment has been processed successfully. Thank you for your
              business!
            </p>
          </div>

          {paymentData ? (
            <div className={styles.paymentDetails}>
              <h2 className={styles.detailsTitle}>Payment Details</h2>
              <div className={styles.detailsGrid}>
                <div className={styles.detailRow}>
                  <span className={styles.detailLabel}>Payment ID:</span>
                  <span className={styles.detailValue}>
                    {paymentData.paymentIntentId}
                  </span>
                </div>
                <div className={styles.detailRow}>
                  <span className={styles.detailLabel}>Amount:</span>
                  <span className={styles.detailValue}>
                    {formatCurrency(paymentData.amount, paymentData.currency)}
                  </span>
                </div>
                <div className={styles.detailRow}>
                  <span className={styles.detailLabel}>Status:</span>
                  <span
                    className={`${styles.detailValue} ${styles.statusSuccess}`}
                  >
                    {paymentData.status}
                  </span>
                </div>
                <div className={styles.detailRow}>
                  <span className={styles.detailLabel}>Date:</span>
                  <span className={styles.detailValue}>
                    {formatDate(
                      paymentData.lastPaymentDate ||
                        paymentData.createdAt ||
                        paymentData.created ||
                        Date.now()
                    )}
                  </span>
                </div>

                {paymentType === "domain_extension" && paymentData.domain ? (
                  <>
                    <div className={styles.detailRow}>
                      <span className={styles.detailLabel}>Domain:</span>
                      <span className={styles.detailValue}>
                        {paymentData.domain}
                      </span>
                    </div>
                    <div className={styles.detailRow}>
                      <span className={styles.detailLabel}>
                        Extension Period:
                      </span>
                      <span className={styles.detailValue}>
                        {paymentData.years} year
                        {paymentData.years > 1 ? "s" : ""}
                      </span>
                    </div>
                  </>
                ) : null}
              </div>
            </div>
          ) : null}

          <div className={styles.nextSteps}>
            <h3 className={styles.nextStepsTitle}>What&apos;s Next?</h3>
            <ul className={styles.nextStepsList}>
              <li>
                {"\u2705"} Payment confirmation email has been sent
              </li>
              <li>
                {"\u2705"} Your service will be activated within 24 hours
              </li>
              <li>
                {"\u2705"} You can track your services in the portal
              </li>
              {paymentType === "domain_extension" ? (
                <li>
                  {"\u2705"} Domain extension will be processed automatically
                </li>
              ) : null}
            </ul>
          </div>

          <div className={styles.actionButtons}>
            <Button type="button" onClick={handleDownloadReceipt}>
              {"\u{1F4C4}"} Download Receipt
            </Button>
            <Button type="button" onClick={handleGoToBilling}>
              View Billing
            </Button>
            <Button type="button" onClick={handleGoToPortal}>
              Go to Portal
            </Button>
          </div>

          <div className={styles.supportInfo}>
            <p className={styles.supportText}>
              Need help? Contact our support team at{" "}
              <a
                href="mailto:support@softindex.ro"
                className={styles.supportLink}
              >
                support@softindex.ro
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
